import React, { Component } from 'react';
import FileInput from 'react-fine-uploader/file-input';
import FineUploaderTraditional from 'fine-uploader-wrappers';
import { connect } from 'react-redux';
import FileListener from './FileListener';
import { Grid, Row, Col, Button, ButtonToolbar } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { withNamespaces } from 'react-i18next';
import { API_ROOT } from '../../../middleware/api';

class FileUpload extends Component {

	constructor(props) {
		super(props);
		this.onFileRemove = this.onFileRemove.bind(this);
		this.uploader = this.createUploader();
	}

	createUploader() {
		return new FineUploaderTraditional({
			options: {
				debug: true,
				request: {
					endpoint: `${API_ROOT}/api/documentUpload`,
					customHeaders: {
						'Accept': 'application/json',
						'X-Franchisor-Id': this.props.franchisorId,
						'Authorization': 'Bearer ' + this.props.accessToken
					}
				},
				chunking: {
					enabled: true,
					partSize: 5000000
				},
				validation: {
					sizeLimit: 5000000
				}
			}
		});
	}

	onFileRemove() {
		const onChange = this.props.input.onChange;
		if (onChange) {
			onChange(null);
		}

		if (this.fileListener) {
			this.fileListener.clear();
		}
	}

	determineAcceptTypes() {
		if (this.props.image) {
			return 'image/*';
		} else {
			return '*';
		}
	}

	renderButtonToolbar(input, t, initialData, uploader, disabled) {
		const acceptTypes = this.determineAcceptTypes();
		const text = {
			selectFile: <span><FontAwesome name='picture-o' /> {t('FO_FileUpload_Choose')}</span>
		};
		return (
			<ButtonToolbar>
				{disabled ||
					<FileInput className='btn btn-primary'
						accept={acceptTypes}
						uploader={uploader}
						text={text} />}
				{input.value &&
					<Button bsStyle='danger' disabled={disabled} onClick={this.onFileRemove}><FontAwesome name='times' /> {t('FileUpload_Remove')}</Button>
				}
			</ButtonToolbar>
		)
	}

	render() {
		const { input, initialData, image, t, disabled } = this.props;
		const buttonToolbar = this.renderButtonToolbar(input, t, initialData, this.uploader, disabled);
		return (
			<Row>
				<Col sm={12}>
					<FileListener uploader={this.uploader}
						input={input}
						initialData={initialData}
						image={image}
						ref={instance => this.fileListener = instance} />
					<Row>
						<Col sm={12}>
							{buttonToolbar}
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

}

const mapStateToProps = state => {
	const {
		configuration,
		auth } = state;

	return {
		franchisorId: configuration.franchisor.id,
		accessToken: auth.accessToken
	};
};

export default withNamespaces()(connect(mapStateToProps)(FileUpload));